import React from "react";
import CommonImageSlider from "./comandata";
import { homeImages, stateBoardImages } from "./data";
import CallandRegisterComponent from "./Callbutton";
import FAQ from "./commonfaq";
import { stateBoard } from "./faqdata";
import SeoMeta from "./seometa";
import { CommonAboutHeader } from "./CommonAboutHeader";


const seopages = {
    title: "Best State Board School in Hyderabad | Rankridge School",
    description:
      "Achieve top scores with Rankridge State Board Schools in Hyderabad. Experienced faculty, strong board exam results, and integrated competitive exam coaching.",
    keywords: "best state board school hyderabad, telangana state board school hyderabad, ap state board school hyderabad, rankridge state board school, state syllabus schools hyderabad, top state board schools hyderabad, state board admissions hyderabad, affordable state board schools hyderabad, high scoring state board schools hyderabad, intermediate state board schools hyderabad, mpc state board schools hyderabad, bipc state board schools hyderabad, state board school with competitive coaching hyderabad, state board science schools hyderabad, best private state board school hyderabad, experienced state board faculty hyderabad, state board exam preparation hyderabad, high pass percentage schools hyderabad, state board merit schools hyderabad, board toppers hyderabad",
    canonical_path: "https://rankridgeschools.com/state-board-education/",
    og_description: "",
    og_image: "",
  };


const title="About Our State Board Education"
 const description="The State Board programme at Rankridge Schools is designed to give children a strong academic base while keeping learning practical, joyful, and stress-free. We believe education should help students feel confident in exams, but also prepare them for real life. Recognized among the trusted State Board schools in Hyderabad, our approach blends the structured syllabus with engaging methods that make concepts clear and easy to grasp. Students develop solid skills in languages, mathematics, science, and social studies, while also exploring arts, sports, and technology. Teachers guide every child with patience and care, encouraging them to ask questions and think independently. At Rankridge, the State Board track is not just about marks,it’s about nurturing capable, well-rounded individuals."

const StateBoard = () => {
  return (
    <div > 
      <h1 className="text-center text-2xl font-bold m-3"> Hyderabad’s Best State Board School – Rankridge for Strong Academic Foundations
</h1>
          <CommonAboutHeader  images={stateBoardImages} title={title} des={description}/>
    

     {/* <CommonImageSlider  images={stateBoardImages}/> */}
     <section className="mt-4 mb-4">
     <CallandRegisterComponent />
</section>
{/* <h2 className="text-2xl text-center capitalize sm:text-2xl font-semibold text-[black]  m-2">  Strong roots in knowledge, high dreams in life – that’s the Rankridge State Board way.
    </h2>


    <section className="m-4">
  <h2 className="text-2xl font-bold text-center">About Rankridge State Board Curriculum School </h2>
<p>At Rankridge School, we believe success in higher education begins with a strong performance in the Board Examinations. Our State Board curriculum for Grades 6 to 10 is carefully designed to help students excel in academics, while also preparing them for competitive exams like NEET, IIT-JEE, EAMCET, Olympiads, and NTSE. With a dual-focus approach, students receive board-oriented subject mastery along with competitive exam readiness, ensuring they are well-prepared for both their immediate academic goals and future career ambitions.</p>
  </section> */}
    <div className=" bg-[#20b2aa] text-[#0e1b3d] px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-48 py-12 space-y-16">
      {/* Tagline Section */}
           
      <div className="grid  grid-cols-1 lg:grid-cols-1 items-center gap-3">

<div className="bg-[white] p-2 ">    
          <h2 className="text-2xl sm:text-2xl font-semibold text-[black] mb-2">
Rankridge State Board School – Where Academic Excellence Meets Holistic Growth
          </h2>
           <p>When it comes to your child’s education, every parent dreams of a school that not only delivers outstanding academic results but also shapes confident, well-rounded individuals. Rankridge State Board School in Hyderabad stands tall as the best state board school in Hyderabad, offering SSC syllabus education from Primary to Secondary levels with a perfect blend of values, modern teaching methods, and personal care.   
        </p>                  
      </div>

        <div className="space-y-4 bg-[white] text-gray-800 text-justify">
            <div className="border border-gray-300 p-6 rounded-xl ">
          <h2 className="text-xl text-[black] font-bold mb-2">Why Parents Trust Rankridge for SSC Syllabus Education?
</h2>
          <p className="mb-5">At Rankridge, we understand that State Board education is more than completing a syllabus it’s about mastering concepts, developing skills, and nurturing lifelong values. Our well-structured SSC curriculum ensures concept-based learning, complete syllabus coverage well before exams, and regular assessments to monitor progress.

         </p>
         <h3 className="font-bold"> Key Advantages:</h3>
          <ul className="list-disc pl-6">
           <li>Top SSC board school in Hyderabad with proven results.</li>
  <li>Integrated coaching for NTSE, Olympiads, and talent tests, preparing students to excel in competitive exams.</li>
  <li>Personalized guidance for every student to help them achieve their highest potential.</li>
  <li>Value-based education for strong moral and ethical grounding.</li>  </ul>
           </div>
         <div className="border border-gray-300 p-6 rounded-xl ">
          <h2 className="text-xl text-[black] font-bold mb-3">Expert Faculty – Mentors Who Make a Difference</h2>
          <p>Our strength lies in our highly qualified and experienced teachers who bring both academic expertise and a passion for teaching. Each faculty member is dedicated to:</p>
          <ul className="list-disc pl-6">
            <li>Making lessons interactive and engaging.</li>
  <li>Encouraging curiosity and creative thinking.</li>
  <li>Providing personalized support for students who need extra guidance.</li>
  <li>Equipping students for SSC board success while building the skills and confidence to tackle future academic challenges.</li>  </ul>
       
         </div>
        <div className="border border-gray-300 p-6 rounded-xl ">
          <h2 className="text-xl text-[black] font-bold mb-3">Beyond Academics – Shaping Future Leaders</h2>
          <p>At Rankridge, we believe education is incomplete without holistic development. That’s why we offer:</p>
          <ul className="list-disc pl-6">
         
  <li>Sports and fitness programs for physical well-being.</li>
  <li>Cultural activities and events to build creativity and teamwork.</li>
  <li>Leadership opportunities through clubs, assemblies, and projects.</li>
  <li>Personality enhancement programs designed to strengthen confidence and refine communication skills.</li>   </ul>
      
           </div>
             <div className="border border-gray-300 p-6 rounded-xl ">
          <h2 className="text-xl text-[black] font-bold mb-3">Safety and Nurturing Environment</h2>
          <p>We know parents value safety as much as academics. Our campus offers:</p>
          <ul className="list-disc pl-6">
           <li>Secure, CCTV-monitored environment.</li>
  <li>Hygienic, well-maintained classrooms and facilities.</li>
  <li>Student-friendly infrastructure designed for comfort and focus.</li>
          </ul>
          </div>
           <div className="border border-gray-300 p-6 rounded-xl ">
          <h2 className="text-xl text-[black] font-bold">Proven SSC Results – Success Stories Every Year</h2>
          <ul className="list-disc pl-6">
            <li>Year after year, Rankridge produces top scorers in SSC Board Exams. Many of our students have gone on to excel in intermediate studies and competitive exams, proving that our foundation for success is strong and reliable.</li>
            </ul>
           </div>
            </div>
          </div>
      <div className="grid grid-cols-1 lg:grid-cols-1 bg-[white] items-center gap-1">
        <div className="space-y-4 text-gray-800 text-justify">
           
           <div className="border border-gray-300 p-6 rounded-xl  ">
          <h2 className="text-xl text-[black] font-bold mb-3">Admissions Open </h2>
          <p>Seats are limited  secure your child’s State Board + Competitive Edge with Rankridge. If you want your child to excel in SSC exams while being ready for IIT-JEE, NEET, or EAMCET, Rankridge is your trusted choice.
</p>
          <ul className="list-disc pl-6">
            <li>📞 +91 99 59 303 873</li>
            <li>📍 Visit our campus to experience why we are the #1 choice for state board school admissions in Hyderabad.</li>
          </ul>
          </div>    
        </div>
        </div>
      </div>
      
        <FAQ data={stateBoard} />

            <SeoMeta seopages={seopages} />


    </div>
  );
};
export default StateBoard